import { ReactNode, useCallback } from 'react';
import { createPortal } from 'react-dom';

import ActivityBuilderInlineSvg from 'approot/shared/inline-svg/activity-builder/activity-builder-inline-svg';
import { useActivityBuilderContext } from '../activity-builder.context';
import { ACTIVITY_BUILDER_DRAWER_ID } from '../activity-builder.constants';
import {
  ACTIVITIES_COMPONENT_TYPE_COLUMNS,
  ActivitiesComponentType,
} from 'global/constants';
import TooltipWrapper from 'approot/shared/tooltip/tooltip-wrapper';
import { SettingsComponentMenuButton } from './settings-component-menu.style';
import SettingsDrawerColumnComponent from './settings-drawer-column-component';

type Props = {
  componentSettings: ReactNode;
  columnSettings?: ReactNode;
  componentId: string;
  columnComponentId?: string;
  type: ActivitiesComponentType;
};

const Settings = ({
  componentSettings,
  columnSettings,
  componentId,
  columnComponentId,
  type,
}: Props) => {
  const { openDrawer, isEditDrawerActive } = useActivityBuilderContext();

  const renderSettings = useCallback(() => {
    if (isEditDrawerActive()) {
      const el = document.getElementById(ACTIVITY_BUILDER_DRAWER_ID);
      if (el) {
        if (type === ACTIVITIES_COMPONENT_TYPE_COLUMNS) {
          return createPortal(<SettingsDrawerColumnComponent />, el);
        }
        return createPortal(componentSettings, el);
      }
    }
    return null;
  }, [type, componentSettings, isEditDrawerActive]);

  const isColumn =
    type === ACTIVITIES_COMPONENT_TYPE_COLUMNS || columnComponentId;

  return (
    <>
      {isColumn && columnSettings}

      {type !== ACTIVITIES_COMPONENT_TYPE_COLUMNS && (
        <TooltipWrapper hoverText="Edit">
          <SettingsComponentMenuButton
            aria-label="Open settings"
            data-selector="settings-menu-edit"
            onClick={() => openDrawer({ componentId })}
          >
            <ActivityBuilderInlineSvg id="icon_pencil" width={18} height={18} />
          </SettingsComponentMenuButton>
        </TooltipWrapper>
      )}
      {renderSettings()}
    </>
  );
};

export default Settings;
